<template>
  <div class="online-content">
    <div class="online-login online-login-common">
      <form action @submit.prevent="loginClick">
        <div class="img">
          <img src="../../assets/images/Login/logo.png" alt />
        </div>
        <div class="tabs-box">
          <span
            class="cursor"
            :class="verify.visible ? 'color-base' : 'color-333'"
            @click="changeWay(0)"
            >{{ $t("Login.account") }}</span
          >
          <span
            class="cursor"
            :class="!verify.visible ? 'color-base' : 'color-333'"
            @click="changeWay(1)"
            >{{ $t("Login.phone") }}</span
          >
        </div>
        <div class="info-box" v-if="verify.visible">
          <div class="verify-psw icon icon1">
            <input
              type="text"
              class="ipt"
              @blur="isTwPhone(verify.account)"
              v-model="verify.account"
              :placeholder="$t('Login.phonePH')"
            />
          </div>
          <div class="verify-psw icon icon2">
            <input
              type="password"
              class="ipt"
              v-model="verify.psw"
              :placeholder="$t('Login.phTips2')"
            />
          </div>
          <div class="forget-box">
            <p class="forget-left" @click="remeberPsw">
              <em
                class="checked"
                :class="verify.rember ? 'SelectChildCur' : 'SelectChild'"
              ></em>
              <span class="cursor">{{ $t("Login.rember") }}</span>
            </p>
            <div class="forget-right color-base cursor" @click="forgetPsw">
              {{ $t("Login.forget") }}
            </div>
          </div>
        </div>
        <div class="info-box" v-else>
          <div class="verify-psw icon icon3">
            <input
              type="text"
              class="ipt"
              @blur="isTwPhone(verify.phone)"
              v-model="verify.phone"
              :placeholder="$t('Login.phonePH')"
            />
          </div>
          <div class="verify-num icon icon4">
            <input
              type="text"
              v-model="verify.test"
              :placeholder="$t('Login.verifyPH')"
              class="ipt"
            />
            <span
              class="getCode bg-base cursor"
              v-if="canGetCode"
              @click="getCode"
              >{{ getCodeTxt }}</span
            >
            <span
              class="getCode"
              v-else
              style="background:#aaa;"
              @click="getCode"
              >{{ leftTime }}s</span
            >
          </div>
        </div>
        <div class="action">
          <button class="btn bg-base btnShadow" type="submit">
            {{ $t("Login.login") }}
          </button>
        </div>
      </form>
    </div>
    <div class="home-bottom">
      <img src="../../assets/images/Login/bottom.png" alt />
    </div>
    <message :message="message" :showTip="showTip" @hideTip="hideTip" />
    <!-- <vue-element-loading :active="isActive" :is-full-screen="true" color="#FF5C67" /> -->
    <!-- 简转繁 -->
    <!-- <div class="simple-change">
    <div class="languag-change languag-change-add tr">
      <span :class="{'active':languageType=='zh'}" @click="handleCommandLanguage('zh')">简</span>
      <span class="line"></span>
      <span :class="{'active':languageType=='tw'}" @click="handleCommandLanguage('tw')">繁</span>
    </div>
  </div> -->
  </div>
</template>

<script>
import loginStore from "./login";
import message from "@/components/Common/message";
import axios from "axios";
const dalu = window.location.host.indexOf("chevady.cn") > -1
  ? "https://stuapi.chevady.cn"
  : "https://stuapi.kidcastle.cn"; //大陆

const tw = "https://stuapi.kidcastleapp.tw"; //台湾
// const regIsTw = /(T0)(\d){9}|(t0)(\d){9}/;//台湾正则
const regIsTw = /^([09](\d){8})|T([09])(\d){8}|t([09])(\d){8}$/;

// import VueElementLoading from 'vue-element-loading'
export default {
  name: "login",
  components: {
    message,
    // VueElementLoading
  },
  data() {
    return {
      isTw: false, //输入的是否是台湾账号
      isActive: false,
      token: "",
      member_id: "",
      message: "",
      showTip: false,
      verify: {
        visible: true,
        rember: false, //记住密码的标识
        account: "", //账号
        psw: "", //密码
        phone: "", //手機號
        test: "", //验证码
      },
      getCodeTxt: this.$t("Login.getPsw"),
      canGetCode: true,
      leftTime: 60,
      languageType: "zh",
    };
  },
  mounted() {},
  updated() {},
  created() {
    let token = this.$route.query.token;
    let mId = this.$route.query.member_id;
    if (token && mId) {
      this.$store.dispatch("setLoadingStatus", true);
      this.changeStuId = this.$route.query.student_id;
      this.token = token;
      this.member_id = mId;
      this.$Tool.setStorage("token", token);
      this.$Tool.setStorage("member_id", mId);
      this.$store.dispatch("setUserToken", token);
      this.$store.dispatch("setMemberId", mId);
      this.getAllStudents();
    } else {
      this.changeStuId = "";
      // this.$Tool.removeStorage("token");
      // this.$Tool.removeStorage("member_id");
      // this.$store.dispatch("setUserToken", '');
      // this.$store.dispatch("setMemberId", '');
      console.log(this.$Tool.getStorage("rember"));
      if (this.$Tool.getStorage("rember")) {
        this.verify.rember = this.$Tool.getStorage("rember");
        this.verify.psw = this.$Tool.getStorage("psw");
        this.verify.account = this.$Tool.getStorage("account");
      } else {
        // this.verify.psw='';
        // this.verify.account='';
      }
      // this.isTw = regIsTw.test(this.verify.account)
      // if (this.isTw) {//台湾
      //   this.languageType = this.$Tool.getStorage("languageType")
      //   ? this.$Tool.getStorage("languageType")
      //   : "tw";
      //   this.$store.dispatch("setLanguageType", this.languageType);
      // } else {//大陆
      //   this.languageType = this.$Tool.getStorage("languageType")
      //   ? this.$Tool.getStorage("languageType")
      //   : "zh";
      //   this.$store.dispatch("setLanguageType", this.languageType);
      // }
    }
  },
  watch: {
    inputVal(val, oldVal) {
      console.log(val, oldVal);
    },
  },
  computed: {},
  methods: {
    //输入手机号 失焦事件
    isTwPhone(v) {
      //regIsTw.test(v) false : 大陆 true:为台湾
      console.log(regIsTw.test(v));
      this.isTw = regIsTw.test(v);
    },
    hideTip() {
      this.showTip = false;
    },
    //切换 登陆 方式
    changeWay(val) {
      console.log(val);
      if (val == 0) {
        this.verify.visible = true;
      } else if (val == 1) {
        this.verify.visible = false;
      }
    },
    //记住密码
    remeberPsw() {
      let psw = this.verify.psw;
      let account = this.verify.account;
      this.verify.rember = !this.verify.rember;
      this.$Tool.setStorage("rember", this.verify.rember); //是否记住密码
      this.$Tool.setStorage("psw", psw); //密码
      this.$Tool.setStorage("account", account); //账号
      // if(this.verify.rember){
      //   console.log(this.verify.rember)
      // }else{
      //   this.$Tool.setStorage("psw", psw);//密码
      //   this.$Tool.setStorage("account", account);//账号
      //   this.verify.psw='';
      //   this.verify.account='';
      // }
    },
    //登录
    loginClick() {
      if (this.verify.visible) {
        console.log(222);
        //账号密码登录
        this.Login();
      } else {
        //验证码登录
        this.MisLogin();
        console.log(111);
      }
    },
    //账号密码登录
    Login() {
      this.$store.dispatch("setLoadingStatus", true);

      let myUrl = "";
      // if (this.isTw) {//台湾
      //   myUrl = tw
      // } else {//大陆
      //   myUrl = dalu
      // }
      if (this.$Tool.getStorage("languageType") == "tw") {
        //台湾
        myUrl = tw;
      } else {
        //大陆
        myUrl = dalu;
      }
      axios
        .get(`${myUrl}/Base/Login`, {
          params: {
            ptcpswd: this.verify.psw, //密码
            ptcmobile: this.verify.account, //账号密码
            language_type:
              this.$Tool.getStorage("languageType") == "tw" ? "tw" : "zh",
          },
        })
        .then((res) => {
          // this.$Tool.setStorage("languageType", this.isTw?'tw':'zh');
          // this.$store.dispatch("setLanguageType", this.isTw?'tw':'zh');
          if (res.data.error == 0) {
            let token = res.data.result.token;
            let member_id = res.data.result.member_id;
            // console.log(token,typeof member_id)
            this.$Tool.setStorage("token", token);
            this.$Tool.setStorage("member_id", member_id);
            this.$store.dispatch("setUserToken", token);
            this.$store.dispatch("setMemberId", member_id);

            this.$Tool.setStorage("psw", this.verify.psw); //密码
            this.$Tool.setStorage("account", this.verify.account); //账号

            this.token = this.$store.state.token;
            this.member_id = this.$store.state.member_id;

            this.getAllStudents();
            // this.$router.push({path:'/'})
          } else {
            this.message = res.data.errortip;
            this.showTip = true;
          }
          this.$store.dispatch("setLoadingStatus", false);
        });
    },
    //验证码 登录
    MisLogin() {
      this.$store.dispatch("setLoadingStatus", true);
      let myUrl = "";
      // if (this.isTw) {//台湾
      //   myUrl = tw
      // } else {//大陆
      //   myUrl = dalu
      // }
      if (this.$Tool.getStorage("languageType") == "tw") {
        //台湾
        myUrl = tw;
      } else {
        //大陆
        myUrl = dalu;
      }
      axios
        .get(`${myUrl}/Base/MisLogin`, {
          params: {
            ptcmobile: this.verify.phone, //手机号码
            ptccode: this.verify.test, //手机验证码/账户密码
            language_type:
              this.$Tool.getStorage("languageType") == "tw" ? "tw" : "zh",
          },
        })
        .then((res) => {
          // this.$Tool.setStorage("languageType", this.isTw?'tw':'zh');
          // this.$store.dispatch("setLanguageType", this.isTw?'tw':'zh');
          if (res.data.error == 0) {
            let token = res.data.result.token;
            let member_id = res.data.result.member_id;
            // console.log(token,typeof member_id)
            this.$Tool.setStorage("token", token);
            this.$Tool.setStorage("member_id", member_id);
            this.$store.dispatch("setUserToken", token);
            this.$store.dispatch("setMemberId", member_id);
            this.token = this.$store.state.token;
            this.member_id = this.$store.state.member_id;
            this.$Tool.setStorage("account", this.verify.phone); //账号
            this.getAllStudents();

            // this.$router.push({path:'/'})
          } else {
            this.message = res.data.errortip;
            this.showTip = true;
          }
          this.$store.dispatch("setLoadingStatus", false);
        });
    },
    //点击 获取 验证码
    getCode() {
      if (this.$Tool.isNull(this.verify.phone)) {
        this.message = this.$t("Login.phoneNull");
        this.showTip = true;
      } else if (this.$Tool.isPhone(this.verify.phone)) {
        if (this.canGetCode) {
          this.getAuthcode();
        }
      } else {
        this.message = this.$t("Login.phoneTips");
        this.showTip = true;
      }
    },
    //获取 验证码
    getAuthcode() {
      let myUrl = "";
      // if (this.isTw) {//台湾
      //   myUrl = tw
      // } else {//大陆
      //   myUrl = dalu
      // }
      if (this.$Tool.getStorage("languageType") == "tw") {
        //台湾
        myUrl = tw;
      } else {
        //大陆
        myUrl = dalu;
      }
      axios
        .get(`${myUrl}/Base/getAuthcode`, {
          params: {
            ptcmobile: this.verify.phone, //手机号码
          },
        })
        .then((res) => {
          this.message = res.data.errortip;
          this.showTip = true;
          if (res.data.error == 0) {
            this.canGetCode = false;
            let timer = setInterval(() => {
              if (this.leftTime > 0) {
                --this.leftTime;
              } else {
                clearInterval(timer);
                this.getCodeTxt = this.$t("Login.again");
                this.canGetCode = true;
                this.leftTime = 60;
              }
            }, 1000);
          }
        });
    },
    //获取全部孩子-接口
    getAllStudents() {
      let myUrl = "";
      // if (this.isTw) {//台湾
      //   myUrl = tw
      // } else {//大陆
      //   myUrl = dalu
      // }
      if (this.$Tool.getStorage("languageType") == "tw") {
        //台湾
        myUrl = tw;
      } else {
        //大陆
        myUrl = dalu;
      }
      axios
        .get(`${myUrl}/Student/getAllStudents`, {
          params: {
            token: this.token, //登陆获取token
            member_id: this.member_id, //登陆获取的会员表
            language_type:
              this.$Tool.getStorage("languageType") == "tw" ? "tw" : "zh",
          },
        })
        .then((res) => {
          if (res.data.error == 0) {
            let studentInfo = res.data.result.list;
            let childList = [...studentInfo];
            let currentChild = studentInfo[0];

            childList.forEach((element, index1) => {
              if (this.changeStuId) {
                if (element.student_id == this.changeStuId) {
                  currentChild = childList[index1];
                  childList[index1].default = true;
                } else {
                  childList[index1].default = false;
                }
              } else {
                childList[index1].default = false;
                childList[0].default = true;
              }
            });
            this.$Tool.setStorage("currentStuInfo", currentChild); //当前学生的个人信息
            this.$Tool.setStorage("childList", childList); // 学生信息
            this.$store.dispatch("setCurrentChild", currentChild);
            window.location.href = '/home';
          } else {
            this.$Tool.setStorage("currentStuInfo", {}); //当前学生的个人信息
            this.$Tool.setStorage("childList", []); // 学生信息
            this.$store.dispatch("setCurrentChild", {});
            this.message = res.data.errortip;
            this.showTip = true;
          }
          this.isActive = false;
          // if(this.$Tool.getStorage("childList").length>0){
          //   window.location.href = '/home';
          // }else{
          //   if(this.$Tool.getStorage("languageType")=='tw'){
          //     this.message = '當前賬號沒有孩子,請綁定孩子';
          //     this.showTip = true;
          //   }else{
          //     this.message = '当前账号没有孩子,请绑定孩子';
          //     this.showTip = true;
          //   }
          // }
        });
    },
    //忘记密码页面-跳转
    forgetPsw() {
      this.$router.push({
        path: "/forgetPsw",
      });
    },
    // 切换语言下拉菜单选择事件
    handleCommandLanguage(command) {
      console.log(command);
      // 切换语言
      this.languageType = command;
      this.$Tool.setStorage("languageType", command);
      this.$store.dispatch("setLanguageType", command);
      location.reload();
    },
  },
};
</script>

<style lang="less">
@import url("./login");
</style>
